type CountColumnProps = { count: number | string };

const CountColumn = ({ count }: CountColumnProps) => (
  <div>
    <span className="px-2 text-center">{count}</span>
  </div>
);

export default CountColumn;
